import type { LogPanelConfig } from "@/shared/state/visualization/schema/v1/log-panel";

/**
 * Whether a log panel's filter bar is open, given its persisted config.
 *
 * A stored `searchVisible` wins outright, including `false` beside saved
 * filters — that is a user who closed the bar, not a stale value.
 *
 * Absent, it falls back to "open when the config carries filters", the rule the
 * panel used before the field existed. The fallback applies whenever the field
 * is absent. Only the toolbar toggle, a filter edit, and a data-source removal on
 * a panel with filters write it; column-width and display-mode writes leave a
 * config without it.
 */
export function resolveSearchVisible(
  config: LogPanelConfig | undefined,
): boolean {
  if (config?.searchVisible !== undefined) {
    return config.searchVisible;
  }
  if (config?.searchFilter !== undefined) {
    return true;
  }
  return Object.keys(config?.columnFilters ?? {}).length > 0;
}
